import { render, staticRenderFns } from "./MenDianPurchaseSalesJinXiaoEdit.vue?vue&type=template&id=52712c5a&scoped=true&"
import script from "./MenDianPurchaseSalesJinXiaoEdit.vue?vue&type=script&lang=js&"
export * from "./MenDianPurchaseSalesJinXiaoEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenDianPurchaseSalesJinXiaoEdit.vue?vue&type=style&index=0&id=52712c5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52712c5a",
  null
  
)

export default component.exports